import defaultClient from 'hub-http/clients/apiClient';
export default ((path, data) => defaultClient.post(path, {
  data
}));